<template>
    <div>
        <div class="subtitle_of_projects">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="20" class="decoration_line">
                    <div class="subtitle_text">
                        DESIGN THEORY
                    </div>
                </el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project13">
                        <div class="image13">
                        </div>
                        <p class="info">Literature review of virtual museum</p>
                    </a>
                </div>
            </el-col>
            <el-col :span="1"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project14">
                        <div class="image14"></div>
                        <p> Product Creative Design Method</p>
                    </a>
                </div>
            </el-col>
            <el-col :span="1"><div class="grid-content"></div></el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
    </div>
        <div class="subtitle_of_projects">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="20" class="decoration_line">
                    <div class="subtitle_text">
                    DIGITAL CREATIVITY
                    </div>
                </el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project12">
                        <div class="image12">
                        </div>
                        <p class="info">Prop-based virtual reality storytelling</p>
                    </a>
                </div>
            </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project1">
                            <div class="image1"></div>
                            <p>VR cultural exhibition</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project2">
                            <div class="image2"></div>
                            <p class="info">VR digital twin</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project3">
                            <div class="image3"></div>
                            <p class="info">AR assisted assembly system</p>
                        </a>
                    </div>
                </el-col>

                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project4">
                            <div class="image4"> </div>
                            <p>V-ray rendering: SSS + PBR material</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project5">
                            <div class="image5">
                            </div>
                            <p class="info">3Dsmax plugin development for faster rendering and modeling work flow</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project11">
                            <div class="image11">
                            </div>
                            <p class="info">3D Voxel Art</p>
                        </a>
                    </div>
                </el-col>

                <el-col :span="1"><div class="grid-content"></div></el-col>

                <el-col :span="1"><div class="grid-content"></div></el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="subtitle_of_projects">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="20" class="decoration_line">
                    <div class="subtitle_text">
                        WEB
                    </div>
                </el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project7">
                        <div class="image7"> </div>
                        <p>Product creativity design tool (WebApp)</p>
                    </a>
                </div>
            </el-col>

            <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project6">
                            <div class="image6">
                            </div>
                            <p class="info">Visualization of knowledge map</p>
                        </a>
                    </div>
                </el-col>
            <el-col :span="1"><div class="grid-content"></div></el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        </div>
        <div class="subtitle_of_projects">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="20" class="decoration_line">
                    <div class="subtitle_text">
                        INDUSTRIAL DESIGN & VISUAL COMMUNICATION DESIGN
                    </div>
                </el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project9">
                            <div class="image9">
                            </div>
                            <p class="info">
                                Zhejiang University guide system design</p>
                        </a>
                    </div>
                </el-col>

                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project10">
                            <div class="image10"> </div>
                            <p>Visual identity and mascot design</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project8">
                            <div class="image8">
                            </div>
                            <p class="info">Product design</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Project",

    }
</script>

<style scoped>
    .grid-content-img{

    }
    .decoration_line{
        border-bottom: 1px solid black ;

    }
    .subtitle_of_projects{

        margin-top: 100px;
        margin-bottom: -70px;
    }
    .subtitle_text{
        font-weight: 200;
    }
    .image1{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/huarongdao_homepage.jpg");
        background-position: center;
        background-size: cover;
    }
    .image2{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/502.jpg");
        background-position: center;
        background-size: cover;
    }
    .image3{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/ar.png");
        background-position: center;
        background-size: cover;
    }
    .image4{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/bunny-pbr2.jpg");
        background-position: center;
        background-size: cover;
    }
    .image5{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/3dmax.png");
        background-position: left;
        background-size: cover;
    }
    .image6{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/knowledgemap.jpg");
        background-position: center;
        background-size: cover;
    }
    .image7{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/cc.jpg");
        background-position: left;
        background-size: cover;
    }
    .image8{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/poster2.jpg");
        background-position: center;
        background-size: cover;
    }
    .image9{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/zheda.jpg");
        background-position: top;
        background-size: cover;
    }
    .image10{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/ip_homepage.jpg");
        background-position: center;
        background-size: cover;
    }
    .image11{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/Harry.png");
        background-position: center;
        background-size: cover;
    }
    .image12{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/VR&P-ST.png");
        background-position: center;
        background-size: cover;
    }
    .image13{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project13_1.jpg");
        background-position: center;
        background-size: cover;
    }
    .image14{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project14_1.jpg");
        background-position: center;
        background-size: cover;
    }
    h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
    }
    .grid-content {
        min-height: 36px;
        border:none;

    }
    .content{
        margin-top:100px;
        margin-bottom: -40px;
    }

    .grid-content-img:hover{
        opacity: 80%;
    }
    .info{
        font-size: 15px;
        color: #666;
        font-weight: 100;
        text-align: center;
        text-decoration: none;
        letter-spacing: 1px;
    }
</style>